module.exports = __webpack_public_path__ + "static/media/radar.aad8b5c1.png";